import { API } from 'aws-amplify'
import { ErrorAnalyticsCallBack, LoggerConfigs, LoggerRoot } from './types'

// eslint-disable-next-line @typescript-eslint/no-empty-function
let errorAnalyticsCb: ErrorAnalyticsCallBack = () => {}
let loggerConfigs: LoggerConfigs = {} as LoggerConfigs
const initializeLogger = (
  logConfigs: LoggerConfigs,
  errorAnalyticsCallback: ErrorAnalyticsCallBack,
): void => {
  loggerConfigs = logConfigs
  errorAnalyticsCb = errorAnalyticsCallback
}

const utcTimestampWithMilliseconds = (): string =>
  new Date().toISOString().replace('T', ':').replace('.', ':').replace('Z', '')

const shouldLogLocally = (): boolean =>
  loggerConfigs.isRunningLocally && !loggerConfigs.forceLogToBackend

const postToBackendLog = async (logMessage: string) => {
  try {
    await API.post(loggerConfigs.apiName, loggerConfigs.apiLogPath, {
      body: {
        logs: [
          {
            message: `${utcTimestampWithMilliseconds()} -- ${logMessage}`,
          },
        ],
        platform: loggerConfigs.platform,
      },
    })
  } catch (err) {
    console.error('postToBackendLog failed: ' + JSON.stringify(err))
  }
}
const debug = async (logMessage: string) => {
  if (loggerConfigs.logLevel === 'DEBUG') {
    if (shouldLogLocally()) {
      console.debug(logMessage)
    } else {
      await postToBackendLog(logMessage)
    }
  }
}
const info = async (logMessage: string) => {
  if (['DEBUG', 'INFO'].includes(loggerConfigs.logLevel)) {
    if (shouldLogLocally()) {
      console.info(logMessage)
    } else {
      await postToBackendLog(logMessage)
    }
  }
}

const warn = async (logMessage: string) => {
  if (['DEBUG', 'INFO', 'WARNING'].includes(loggerConfigs.logLevel)) {
    if (shouldLogLocally()) {
      console.warn(logMessage)
    } else {
      try {
        await postToBackendLog(logMessage)
      } catch (error) {
        errorAnalyticsCb(logMessage)
      }
    }
  }
}

const error = async (logMessage: string) => {
  if (['DEBUG', 'INFO', 'WARNING', 'ERROR'].includes(loggerConfigs.logLevel)) {
    if (shouldLogLocally()) {
      console.error(logMessage)
    } else {
      try {
        await postToBackendLog(logMessage)
      } catch (error) {
        errorAnalyticsCb(logMessage)
      }
    }
  }
}

//Legacy Soon to be deprecated
const logToBackend = async (msg: string) => {
  if (shouldLogLocally()) {
    console.log(msg)
  } else {
    await postToBackendLog(msg)
  }
}

const logHTMLToBackend = async (html: string, url?: string) => {
  if (loggerConfigs.isRunningLocally && !loggerConfigs.forceLogToBackend) {
    return
  }
  try {
    await API.post(loggerConfigs.apiName, loggerConfigs.apiHtmlPath, {
      body: {
        content: html,
        ...(url && { url }),
      },
    })
  } catch (err) {
    console.error('logHTMLToBackend post failed: ' + JSON.stringify(err))
    errorAnalyticsCb('logHTMLToBackend post failed: ', err)
  }
}

export const Logger: LoggerRoot = {
  initializeLogger,
  logToBackend,
  logHTMLToBackend,
  debug,
  info,
  warn,
  error,
}
